import React, { createContext, useReducer } from "react";
import Reducer from "./reducer";

const initialState = {
  drawer: false,
  loader: false,
  reviews: require("../data/data.json").sort(function (a, b) {
    return new Date(b.createdAt) - new Date(a.createdAt);
  })
};

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

export const Context = createContext(initialState);

export default Store;
